import styleInject from '#style-inject';styleInject(".GifPickerReact .gpr-result-placeholder{border-radius:var(--gpr-category-border-radius)}\n")